import { isDefined } from '@aloft/toolkit-shared';

import { MonthGrouping, ZillowHomeValueIndexTrendsData } from '../zillow/types.ts';

export type TrendsChartDataType = {
  inner: MonthGrouping;
  month: string;
  historical: number | null;
  projection: number | null;
  comps?: string;
};

export const getHousingTrendsChartData = (
  trends?: ZillowHomeValueIndexTrendsData,
): TrendsChartDataType[] => {
  if (!trends) return [];

  const data: TrendsChartDataType[] = trends.historical.map((val, i) => {
    return {
      inner: val,
      month: val.month,
      historical: val.typicalValue.toDollarLike(),
      // Workaround to draw a line for projection
      projection: i === trends.historical.length - 1 ? val.typicalValue.toDollarLike() : null,
      comps: val.affectedComps,
    };
  });

  if (isDefined(trends.projection))
    trends.projection.forEach((val) =>
      data.push({
        inner: val,
        month: val.month,
        historical: null,
        projection: val.typicalValue.toDollarLike(),
        comps: val.affectedComps,
      }),
    );

  return data;
};
